import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.jpeg';
import { apiService } from '../services/apiService';

const ResetPassword = () => {
  const navigate              = useNavigate();
  const token                 = new URLSearchParams(window.location.search).get('token') || '';
  const [form, setForm]       = useState({ newPassword: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.newPassword !== form.confirm) {
      setMessage({ type: 'error', text: 'Passwords do not match.' });
      return;
    }
    if (form.newPassword.length < 6) {
      setMessage({ type: 'error', text: 'Password must be at least 6 characters.' });
      return;
    }
    try {
      setLoading(true);
      setMessage(null);
      await apiService.post('auth/reset-password', { token, newPassword: form.newPassword });
      setMessage({ type: 'success', text: 'Password reset successfully! Redirecting to login...' });
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Reset failed. The link may have expired.' });
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ maxWidth: 460, textAlign: 'center' }}>
          <p style={{ color: '#721c24' }}>Invalid reset link.</p>
          <Link to="/forgot-password" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
            Request a new link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 460 }}>
        <div className="auth-header">
          <img src={logo} alt="MCCT Logo" style={{ height: 72, marginBottom: '1rem', borderRadius: 8 }} />
          <h2>Reset Password</h2>
          <p style={{ color: 'var(--text-light)', marginTop: '0.25rem' }}>Enter your new password below.</p>
        </div>

        {message && (
          <div style={{
            padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem',
            background: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color:      message.type === 'success' ? '#155724' : '#721c24',
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>New Password</label>
            <input
              type="password" value={form.newPassword} minLength={6} required
              onChange={e => setForm(p => ({ ...p, newPassword: e.target.value }))}
              placeholder="At least 6 characters"
            />
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input
              type="password" value={form.confirm} minLength={6} required
              onChange={e => setForm(p => ({ ...p, confirm: e.target.value }))}
              placeholder="Repeat new password"
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.9rem' }}>
          <Link to="/login" style={{ color: 'var(--primary-color)' }}>← Back to Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
